export default "__VITE_ASSET__BeomEUC4__"